import React from 'react';

import {AxisDropdown} from '../common/AxisDropdown';
import {useMediaSettingsDrawerContext} from '../MediaSettingsDrawerContextProvider';

export const ColumnContent = () => {
  const {config, updateConfig} = useMediaSettingsDrawerContext();
  return (
    <AxisDropdown
      configField="gallerySettings"
      initialValue={config.gallerySettings.axis}
      onSelectOption={option => updateConfig({gallerySettings: {axis: option}})}
      title="Column content"
    />
  );
};
